
import { getTranslationFromTextStructure } from '../common/translationsCommon'
import { questionTypes } from '../surveys/QuestionWidget'
import { nonApplicableSuffix } from '../surveys/SurveyTab'
import { actionsTemplatesConditions } from './ActionTemplates'
import './AvaliableActions.css'

export const categoryToKey = {
  'Financial Managment': 'financial',
  'Property Management': 'property',
  'Social and community relations': 'social',
  Governance: 'governance'
}

export const scoreToValue = (qValue, score) => {
  // const score = scoreCard[toCheck]
  if (!score) {
    console.warn('condition has no score')
    return 0
  }
  if (typeof qValue === 'object') {
    // select multiple
    let sum = 0
    let maxNum = 0
    qValue.forEach((v, index) => {
      const answer = +score['Option ' + (index + 1)]
      if (typeof answer === 'number' && answer > 0) {
        maxNum += +answer
      }
    })
    qValue.forEach((v, index) => {
      const answer = +score['Option ' + (index + 1)]
      if (typeof answer === 'number') {
        if (v) {
          sum += answer
        }
      }
    })
    return maxNum === 0 ? 0 : Number((sum / maxNum) * 100).toFixed(0)
  } else {
    // Select one
    const optIndex = parseInt(qValue.split('_')[1], 10) + 1
    let currentValue = score['Option ' + optIndex] || 0
    currentValue = parseFloat((currentValue + '').replace(',', '.'))
    if (isNaN(currentValue)) {
      // option is not scoring
      return null
    }
    let maxValue = 0
    for (let index = 1; index < 13; index++) {
      let opt = score['Option ' + index]
      opt = parseFloat((opt + '').replace(',', '.')) || 0
      if (opt > maxValue) {
        maxValue = opt
      }
    }
    const p = maxValue === 0 && currentValue === 0 ? 0 : currentValue / maxValue
    const percent = Number((p * 100).toFixed(0))
    return percent
  }
}

export const getPriorityScore = ({
  condition,
  surveyAnswers,
  scoreCard,
  sectionScores
}) => {
  let toRet = 0
  if (condition.question) {
    const type = condition.questionType
    let qValue = surveyAnswers[condition.question]
    if (condition.parentQuestion) {
      if (surveyAnswers[condition.parentQuestion]) {
        qValue = surveyAnswers[condition.parentQuestion][condition.childIndex]
      } else {
        return toRet
      }
    } else if (condition.childQuestions) {
      let num = 0
      let sum = 0
      condition.childQuestions.forEach(child => {
        const childValue = surveyAnswers[condition.question][num]
        if (condition.questionType === questionTypes.SELECT_ONE.id) {
          const toCheck = condition.question + '.' + num
          sum += scoreToValue(childValue, scoreCard[toCheck])
        } else if (condition.questionType === questionTypes.SELECT_YESNO.id) {
          sum += childValue === 'option_0' ? 100 : 0
        } else if (
          type === questionTypes.INPUT_TEXT.id ||
          type === questionTypes.INPUT_TEXTAREA.id
        ) {
          sum += childValue ? 100 : 0
        } else {
          sum += childValue
        }
        num++
      })
      qValue = sum / num
      return qValue
    }
    if (type === questionTypes.SELECT_ONE.id) {
      const toCheck = condition.parentQuestion
        ? condition.parentQuestion + '.' + condition.childIndex
        : condition.question
      return scoreToValue(qValue, scoreCard[toCheck])
    } else if (type === questionTypes.SELECT_YESNO.id) {
      return qValue === 'option_0' ? 100 : 0
    } else if (type === questionTypes.SELECT_MULTIPLE.id) {
      return scoreToValue(qValue, scoreCard[condition.question])
    } else if (
      type === questionTypes.INPUT_TEXT.id ||
      type === questionTypes.INPUT_TEXTAREA.id
    ) {
      return qValue ? 100 : 0
    }
  } else if (condition.type === 'category') {
    const sectionData = sectionScores[condition.category]
    if (sectionData) {
      return Number((sectionData.percent * 100).toFixed(0))
    }
  } else if (condition.type === 'logical') {
    let max = 100
    if (condition.operator === 'or') {
      max = 0
      condition.subconditions.forEach(sub => {
        const subScore = getPriorityScore({
          condition: sub,
          scoreCard,
          surveyAnswers,
          sectionScores
        })
        if (subScore > max) {
          max = subScore
        }
      })
      toRet = max
    }
  }
  return toRet
}

export const testCondition = ({
  condition,
  surveyAnswers,
  sectionScores,
  scoreCard,
  surveyTemplateId
}) => {
  let toRet = false
  if (condition.question) {
    const type = condition.questionType
    const isText = Boolean(
      type === questionTypes.INPUT_TEXT.id ||
        type === questionTypes.INPUT_TEXTAREA.id
    )
    let qValue = surveyAnswers[condition.question]
    let questionId = condition.question
    if (condition.parentQuestion) {
      questionId = condition.parentQuestion
      if (surveyAnswers[questionId]) {
        qValue = surveyAnswers[questionId][condition.childIndex]
      } else {
        // QUESTION NOT IN TEMPLATE, CONDITION IS FALSE BY DEFAULT
        return false
      }
    } else if (condition.childQuestions) {
      if (surveyAnswers[questionId + nonApplicableSuffix]) {
        return false
      } else if (!surveyAnswers[condition.question]) {
        return false
      }
      let num = 0
      let sum = 0
      condition.childQuestions.forEach(child => {
        const childValue = surveyAnswers[condition.question][num]
        if (condition.questionType === questionTypes.SELECT_ONE.id) {
          const toCheck = condition.question + '.' + num
          const scoreValue = scoreToValue(childValue, scoreCard[toCheck])
          if (scoreValue !== null) {
            sum += scoreValue
          } else {
            return
          }
        } else if (condition.questionType === questionTypes.SELECT_YESNO.id) {
          sum += childValue === 'option_0' ? 100 : 0
        } else {
          sum += childValue || 0
        }
        num++
      })
      qValue = sum / num
      if (!condition.operator) {
        return false
      }
      return actionsTemplatesConditions[condition.operator](
        qValue,
        Number(condition.value)
      )
    }
    if (Array.isArray(surveyAnswers[questionId + nonApplicableSuffix])) {
      if (
        surveyAnswers[questionId + nonApplicableSuffix][condition.childIndex]
      ) {
        return false
      }
    } else if (surveyAnswers[questionId + nonApplicableSuffix]) {
      return false
    }
    if (!qValue && !isText) {
      return toRet
    }
    if (type === questionTypes.SELECT_ONE.id) {
      const toCheck = condition.parentQuestion
        ? condition.parentQuestion + '.' + condition.childIndex
        : condition.question
      qValue = scoreToValue(qValue, scoreCard[toCheck])
      if (qValue === null) {
        // non scoring answer means the condition is false
        return false
      }
    } else if (type === questionTypes.SELECT_YESNO.id) {
      qValue = qValue === 'option_0' ? 100 : 0
    } else if (type === questionTypes.SELECT_MULTIPLE.id) {
      if (condition.operator === 'all') {
        return !qValue.some((option, index) => {
          if (!condition.options.includes(String(index))) {
            return false
          } else {
            return !option
          }
        })
      } else if (condition.operator === 'any') {
        return qValue.some(
          (option, index) => condition.options.includes(String(index)) && option
        )
      }
      return false
    } else if (isText) {
      if (!condition.operator) {
        return false
      }
      return (
        Boolean(condition.operator === 'empty' && !qValue) ||
        Boolean(condition.operator === 'notEmpty' && qValue)
      )
    }
    if (!condition.operator) {
      return false
    }
    toRet = actionsTemplatesConditions[condition.operator](
      qValue,
      Number(condition.value)
    )
  } else if (condition.type === 'category') {
    const sectionData = sectionScores[condition.category]
    if (sectionData) {
      const percent = Number((sectionData.percent * 100).toFixed(0))
      toRet = actionsTemplatesConditions[condition.operator](
        percent,
        Number(condition.value)
      )
    }
  } else if (condition.type === 'logical') {
    if (condition.operator === 'or') {
      return condition.subconditions.some(sub =>
        testCondition({
          condition: sub,
          surveyAnswers,
          sectionScores,
          scoreCard,
          surveyTemplateId
        })
      )
    }
  } else if (condition.type === 'template') {
    return condition.template === surveyTemplateId
  }
  return toRet
}

export const parseActionTemplatesToScoring = ({
  actionTemplates,
  user,
  skippedSections,
  sectionScores,
  surveyTemplateId,
  scoreCard,
  surveyAnswers
}) => {
  const toSet = []
  actionTemplates.forEach(template => {
    let actionDisabled = false
    const conditions = JSON.parse(template.JSON__c)
    const priorityConditions = template.Priority_Conditions__c
      ? JSON.parse(template.Priority_Conditions__c)
      : []
    conditions.some(condition => {
      actionDisabled = !testCondition({
        condition,
        surveyAnswers,
        sectionScores,
        scoreCard,
        surveyTemplateId
      })
      return actionDisabled
    })
    if (skippedSections.includes(categoryToKey[template.Category__c])) {
      actionDisabled = true
    }
    if (!actionDisabled) {
      let priority = sectionScores[categoryToKey[template.Category__c]]
      if (priority) {
        const base = template.Base_Priority__c || 0
        priority = base + (100 - priority.percent * 100)
      } else {
        priority = 0
      }
      priorityConditions.forEach(pCondition => {
        if (
          testCondition({
            condition: pCondition,
            surveyAnswers,
            sectionScores,
            scoreCard,
            surveyTemplateId
          })
        ) {
          if (
            pCondition.flatValue &&
            pCondition.priorityCalculation === 'flatValue'
          ) {
            priority += +pCondition.flatValue
          } else if (pCondition.priorityCalculation === 'fromScore') {
            priority +=
              100 -
              getPriorityScore({
                condition: pCondition,
                surveyAnswers,
                scoreCard,
                sectionScores
              })
          }
        }
      })
      const name = getTranslationFromTextStructure({ userLang: user.language, titleTranslation: template.Title__c })
      const description = getTranslationFromTextStructure(
        {
          userLang: user.language,
          titleTranslation: template.Description__c
        }
      )
      const outcome = getTranslationFromTextStructure(
        {
          userLang: user.language,
          titleTranslation: template.Expected_Outcome__c
        }
      )
      const reason = getTranslationFromTextStructure({ userLang: user.language, titleTranslation: template.Reason__c })

      if (name) {
        toSet.push({
          name,
          description,
          priority,
          category: template.Category__c,
          templateId: template.Id,
          conditions,
          outcome,
          timeline: template.Timeline__c,
          reason
        })
      }
    }
  })
  toSet.sort((a, b) => {
    if (a.priority === b.priority) {
      return a.name.localeCompare(b.name)
    }
    return b.priority - a.priority
  })
  return toSet
}
